import React, { forwardRef, useEffect, useRef, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { Box, DialogContent, styled } from '@mui/material';
import { motion } from 'framer-motion';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import Feed from '../feed';
import { DOMAIN } from '../../config';
import CustomizedProgressBars from '../common/loading';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

export default function MoviesDialog({ setOpenMovies, openMovies, matches, chipTitle }) {
  const [latest, setLatest] = useState([]);
  const [empty, setEmpty] = useState(false);
  const touchStartRef = useRef(0);

  const handleTouchStart = (event) => {
    event.stopPropagation();
    touchStartRef.current = event.touches[0].clientX;
  };

  const handleSwipe = (event) => {
    const touchEndX = event.changedTouches[0].clientX;
    const swipeDistance = touchStartRef.current - touchEndX;
    if (swipeDistance > 120) {
      setOpenMovies(false);
    }
  };

  const handleClose = () => {
    setOpenMovies(false);
  };

  useEffect(() => {
    if (!openMovies) return;

    fetch(`${DOMAIN}ywyminiappbot/movies?page=1`)
      .then((res) => res.json())
      .then((data) => {
        if (!data || data.length === 0) {
          setEmpty(true);
          setLatest([]);
        } else {
          setEmpty(false);
          setLatest(data);
        }
      });
  }, [openMovies]);

  return (
    <Box>
      <Dialog
        fullScreen
        open={openMovies}
        onClose={handleClose}
        TransitionComponent={Transition}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleSwipe}
        PaperProps={{
          onTouchStart: handleTouchStart,
          onTouchEnd: handleSwipe,
        }}
      >
        <AppBar
          position="sticky"
          elevation={0}
          sx={{
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            backgroundColor: 'rgba(255,255,255,0.25)',
            color: '#000',
          }}
        >
          <Toolbar sx={{ minHeight: 45 }}>
            <motion.div
              initial={{ x: '100vw', opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ type: 'spring', stiffness: 300, damping: 30 }}
              style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%' }}
            >
              <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                <CloseIcon fontSize="small" />
              </IconButton>

              <Typography
                variant="subtitle1"
                component="div"
                sx={{ fontWeight: 500, fontSize: 16, flex: 1 }}
              >
                {chipTitle}
              </Typography>
            </motion.div>
          </Toolbar>
        </AppBar>

        <DialogContent
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: 0,
            paddingTop: 45,
            overflowY: 'auto',
          }}
        >
          {latest.length > 0 && (
            <Feed
              matches={matches}
              latest={latest}
              setLatest={setLatest}
              fetchUrl={`${DOMAIN}ywyminiappbot/movies`}
              remark={false}
              title="电影"
            />
          )}

          {empty && (
            <Box
              style={{
                display: 'flex',
                justifyContent: 'center',
                flexFlow: 'row',
                padding: '200px 0',
                color: '#999',
              }}
            >
              <SearchOffIcon />
              <Typography variant="h6" fontSize={14}>
                没有此内容，我们会尽快发布...
              </Typography>
            </Box>
          )}

          {!latest.length && <CustomizedProgressBars />}
        </DialogContent>
      </Dialog>
    </Box>
  );
}

const BlinkingButton = styled(Button)(({ theme }) => ({
  animation: 'blinking 1.8s infinite',
  '@keyframes blinking': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.7 },
    '100%': { opacity: 1 },
  },
}));
